const formats = [
  {
    icon: 'ri-calendar-check-line',
    title: 'Корпоративный тренинг',
    desc: 'Практическая программа на 1–2 дня. Интенсивная отработка сложных разговоров: алгоритмы, ролевые ситуации, разбор реальных кейсов участников.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Модульная программа',
    desc: 'Несколько встреч с практикой между модулями. Руководители проводят реальные сложные разговоры и возвращаются с опытом для разбора.',
  },
  {
    icon: 'ri-gamepad-line',
    title: 'Бизнес-игры',
    desc: 'Моделирование сложных управленческих ситуаций в игровом формате. Безопасная среда для отработки навыков с высокой вовлечённостью.',
  },
  {
    icon: 'ri-user-voice-line',
    title: 'Индивидуальный коучинг',
    desc: 'Разбор конкретных разговоров и управленческих задач руководителя. Подготовка к предстоящему сложному разговору и анализ прошедшего.',
  },
  {
    icon: 'ri-phone-line',
    title: 'Сопровождение',
    desc: 'Поддержка руководителей после обучения: разбор реальных разговоров, корректировка подхода, ответы на вопросы по конкретным ситуациям.',
  },
  {
    icon: 'ri-computer-line',
    title: 'Онлайн',
    desc: 'Дистанционный формат с практическими заданиями и разбором ситуаций. Подходит для распределённых команд и модульных программ.',
  },
];

export default function FormatsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Форматы обучения
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-4 max-w-3xl mx-auto leading-relaxed">
          Конкретный формат определяется после обсуждения задачи компании
        </p>
        <p className="text-sm text-gray-500 text-center mb-12 max-w-2xl mx-auto">
          Мы не предлагаем шаблонное решение. Сначала разбираемся в ситуации и только потом предлагаем подходящий формат.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {formats.map((f) => (
            <div key={f.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${f.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{f.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}